export const loginConstants = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGIN_CANDIDATE_REQUEST: "LOGIN_CANDIDATE_REQUEST",
  LOGIN_CANDIDATE_SUCCESS: "LOGIN_CANDIDATE_SUCCESS",
  LOGIN_CANDIDATE_SUCCESS_NEW: "LOGIN_CANDIDATE_SUCCESS_NEW",
  LOGIN_CANDIDATE_FAILURE: "LOGIN_CANDIDATE_FAILURE",
  CLEAR_CANDIDATE_REDIRECT: "CLEAR_CANDIDATE_REDIRECT",
  MISSING_CREDENTIALS:"MISSING_CREDENTIALS",
  HIDE_SMS_MODAL: "HIDE_SMS_MODAL",
  LOGOUT: "LOGOUT",
  ADD_LEAD_REQUEST: "ADD_LEAD_REQUEST",
  ADD_LEAD_SUCCESS: "ADD_LEAD_SUCCESS",
  ADD_LEAD_FAILURE: "ADD_LEAD_FAILURE",

  LOGIN_OTP_REQUEST: "LOGIN_OTP_REQUEST",
  LOGIN_OTP_SUCCESS: "LOGIN_OTP_SUCCESS",
  LOGIN_OTP_FAILURE: "LOGIN_OTP_FAILURE",
  LOGIN_OTP_SMSVERIFY: "LOGIN_OTP_SMSVERIFY",
  LOGIN_OTP_EPOSTAVERIFY: "LOGIN_OTP_EPOSTAVERIFY",
  LOGIN_OTP_EXPIREPASSWORD: "LOGIN_OTP_EXPIREPASSWORD",

  LOGIN_VERIFY_REQUEST: "LOGIN_VERIFY_REQUEST",
  LOGIN_VERIFY_SUCCESS: "LOGIN_VERIFY_SUCCESS",
  LOGIN_VERIFY_FAILURE: "LOGIN_VERIFY_FAILURE",
  
  RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",
};
